import React, { useState } from 'react';
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';
import '../styles/Login.scss';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!username || !password) {
            setError('Kérjük, töltse ki mindkét mezőt!');
            setLoading(false);
            return;
        }

        try {
            const success = await login(username, password);
            if (success) {
                navigate('/admin');
            } else {
                setError('Hibás felhasználónév vagy jelszó!');
            }
        } catch (err) {
            setError('Bejelentkezési hiba történt. Kérjük, próbálja újra!');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <Container maxWidth="sm">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <Paper elevation={3} className="login-paper">
                        <Typography variant="h4" className="login-title">
                            Bejelentkezés
                        </Typography>
                        <Typography variant="body2" color="textSecondary" className="login-subtitle">
                            Admin felület
                        </Typography>

                        {error && (
                            <Alert severity="error" className="login-alert">
                                {error}
                            </Alert>
                        )}

                        <Box component="form" onSubmit={handleSubmit} className="login-form">
                            <TextField
                                fullWidth
                                label="Felhasználónév"
                                variant="outlined"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="login-input"
                                disabled={loading}
                            />
                            <TextField
                                fullWidth
                                label="Jelszó"
                                type="password"
                                variant="outlined"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="login-input"
                                disabled={loading}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="large"
                                className="login-button"
                                disabled={loading}
                            >
                                {loading ? 'Bejelentkezés...' : 'Bejelentkezés'}
                            </Button>
                        </Box>
                    </Paper>
                </motion.div>
            </Container>
        </div>
    );
};

export default Login; 